import { createContext, ReactNode, useContext } from 'react';
import { PaginationContextType, usePagination } from '../../search-windows/use-pagination';

const PaginationContext = createContext<PaginationContextType | undefined>(undefined);

export function useBoloSearchResultsPaginationContext() {
    const context = useContext(PaginationContext);
    if (context === undefined) {
        throw new Error(
            'useBoloSearchResultsPaginationContext must be used within a BoloSearchResultsPaginationProvider'
        );
    }
    return context;
}

export const BoloSearchResultsPaginationProvider = ({ children }: { children: ReactNode }) => {
    const pagination = usePagination();
    return <PaginationContext.Provider value={pagination}>{children}</PaginationContext.Provider>;
};
